export const DefaultPassword = 'Bpsf2024';